/**
 * ToastContainer — renders global toast notifications.
 */
import { useUIStore } from '@/stores/uiStore';
import { cn } from '@/lib/utils';

const VARIANT_STYLES = {
  default: 'bg-slate-700 border-slate-600 text-slate-100',
  success: 'bg-green-900/80 border-green-700 text-green-100',
  destructive: 'bg-red-900/80 border-red-700 text-red-100',
  warning: 'bg-amber-900/80 border-amber-700 text-amber-100',
};

export default function ToastContainer() {
  const { toasts, removeToast } = useUIStore();

  return (
    <div className="fixed bottom-6 left-1/2 z-[100] flex -translate-x-1/2 flex-col gap-2 px-4">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            'flex items-start gap-3 rounded-xl border px-4 py-3 shadow-xl animate-fade-in min-w-72 max-w-sm',
            VARIANT_STYLES[toast.variant] || VARIANT_STYLES.default
          )}
        >
          <div className="flex-1">
            {toast.title && <p className="text-sm font-semibold">{toast.title}</p>}
            {toast.description && <p className="mt-0.5 text-xs opacity-80">{toast.description}</p>}
          </div>
          <button
            onClick={() => removeToast(toast.id)}
            className="mt-0.5 shrink-0 text-xs opacity-60 hover:opacity-100"
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
